import styled from "styled-components";

export const Container = styled.div`
	max-width: 300px;
	margin: 0 auto;
`
